import { subSeconds } from 'date-fns'

import { refresh } from '@shared/api/auth'

import { AUTH_COOKIE_NAME, CookieManager, LAST_USER_ACTIVE_TIME_COOKIE_NAME } from './CookieManager'

export const EXPIRY_REFRESH_THRESHOLD_SECONDS = 900 // 15 minutes

const refreshToken = async (token: string) => {
  const apiResponse = await refresh(token)

  if (!apiResponse.ok) return null

  const authHeader = apiResponse.headers.get('Authorization')

  const newToken = authHeader ? authHeader.replace('Bearer ', '') : null
  return newToken
}

export const refreshTokenIfExpiring = async () => {
  const cookieManager = new CookieManager(AUTH_COOKIE_NAME)
  const lastUserActiveTimeCookieManager = new CookieManager(LAST_USER_ACTIVE_TIME_COOKIE_NAME)
  const cookie = cookieManager.getCookieJwt()
  const lastUserActiveTime = parseInt(lastUserActiveTimeCookieManager.getCookie() || '0', 10)

  if (cookie.expiresAt === null || cookie.expiresAt === undefined) return
  if (lastUserActiveTime === 0) return

  const expireThreshold = subSeconds(new Date(cookie.expiresAt), EXPIRY_REFRESH_THRESHOLD_SECONDS).getTime()

  if (Date.now() > expireThreshold && lastUserActiveTime > expireThreshold) {
    const newToken = await refreshToken(cookie.value)
    if (newToken) cookieManager.setCookieJwt(newToken)
  }
}
